import type { FilesProxySchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { getProxyMediaType } from './get_proxy_media_type';
import {
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_STREAM,
  MEDIA_TYPE_VIDEO,
  type MediaType,
} from './media_type';

const mediaTypePriority: MediaType[] = [
  MEDIA_TYPE_VIDEO,
  MEDIA_TYPE_STREAM,
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_IMAGE,
];

// Unknown/unclassifiable media types sort after every recognized media type.
function mediaTypeRank(proxy: FilesProxySchemaWithId): number {
  const mediaType = getProxyMediaType(proxy);
  return mediaType
    ? mediaTypePriority.indexOf(mediaType)
    : mediaTypePriority.length;
}

export function sortByMediaTypeAndDate(
  a: FilesProxySchemaWithId,
  b: FilesProxySchemaWithId,
) {
  const priorityA = mediaTypeRank(a);
  const priorityB = mediaTypeRank(b);

  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }

  // Order by date_created descending (latest first) if media types are the same
  return b.date_created?.localeCompare(a?.date_created ?? '') ?? 0;
}
